export class providerDTO{
    id:number;
    providerName:string;
    Specialities:string;
    Address1:string;
    Address2:string;
    City:string;
    County: string;
    State: string;
    ZipCode: string;
    PhoneNumber:string;
    noOfRepeats:number;
    DIRECTORYSPECIALTY:string;
    SpeakingLanguages:string;
    newPatientsFlag:string;
    BoardCertified:string;
    distanceinMiles:number;
    provLatitude:string
    provLongitude:string
    providerType:string
}

export class organizationDTO
{
    orgunitId:number;
    orgName:string;
    orgCode:string;
    orgContentPath:string;
    themeFolder:string;
    logoSrc:string;
    orgEmail:string;
    orgPhone:string;
    customerCarePhone:string;
    weekDayWorkingHrs:string;
    weekEndWorkingHrs:string;
    footerNotes:string;
    copyRightText:string;
    needPrintVersionText:string;
    otherResourcesText:string;
    facebookLink:string;
    twitterLink:string;
    linkedInLink:string;
    instagramLink:string;
    youtubeLink:string;
    siteFolder:string;
    contactInformation:string;
}

export class contactUsDTO{
    id:number;
    firstName:string;
    middleName:string;
    lastName:string;
    phone:string;
    email:string;
    subject:string;
    Notes:string;
    contactDateTime:string;
    acknowledgementStatus:string;
    reportSupportStatus:string;

}
export class faqDTO{
    faqId: number ;
	Question: string ;
	Description: string ;
    Category:string ;
	DisplayOrder :number ;
	CreatedDateTime:Date ;
	CreatedBy:string ;
	ModifiedDateTime:string ;
	ModifiedBy:string ;
	Status:string ;

}
export class CategoryDTO{
    CategoryId: number ;
	CategoryName: string ;
	CategoryDescription: string ;
    DisplayOrder:number ;
	Status:string ;
}

export class printRequestDTO{
    Id:number;
	firstName:string;
	lastName:string;
	middleName:string;
	email:string;
	directoryAddress1:string
	directoryAddress2:string;
	directoryCity:string;
	directoryState:string;
	directoryZipcode:number;
	shippingAddress1:string;
	shippingAddress2:string;
	shippingCity:string;
	shippingState:string;
	shippingZipcode:number;
	phoneNumber:string;
	planType:string;
	directoryType:string;
	Notes:string;
	requestSubmitDateTime:Date;
	acknowledgementStatus:number;
	portalAdminNotifyStatus:number;
	Status:number;
}

export class statesDTO{
    stateCode:string;
    stateName:string;
}

export class emailNotificationDTO{
    Title:string;
    From:string;
    To:string;
    Subject:string;
    Content:string;
    Cc:string;
    Bcc:string;
}

export enum notificationType{
    ContactUsAcknowledgement="ContactUsAcknowledgement",
    ContactUsReport="ContactUsReport",
    PrintRequestAcknowledgement="PrintRequestAcknowledgement",
    PrintRequestReporting="PrintRequestReporting",
}

export class emailNotificationQueue{
fromEmail
toEmail
ccEmail
subject
Notes
notificationType
Status
noOfAttempts
}